"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleCopy = exports.handleQuestions = exports.handleMessage = exports.handleMessages = exports.handleUserGroups = exports.handleTender = exports.handleParticipants = exports.handleList = exports.handleFinishing = exports.handleCurrentAddendum = exports.handleCurrentBid = exports.handleBillingInformation = exports.handleBasicInformation = exports.initialState = void 0;
const fp = require("fp-ts");
const monocle = require("monocle-ts");
const basicInformationReducer = require("./basicInformation");
const finishingsReducer = require("./finishings");
const listReducer = require("./list");
const participantsReducer = require("./participants");
const tenderReducer = require("./tender");
const reliablePartnerSettingsReducer = require("./reliablePartnerSettings");
const userGroupsReducer = require("./userGroups");
const messagesReducer = require("./messages");
const messageReducer = require("./message");
const questionsReducer = require("./questions");
const _currentReducer = require("../../modules/bid/current/reducers");
const _folderTreeReducer = require("../../modules/files/tree/reducers");
const _billingInformationsReducer = require("./billingInformation");
const subreducers_1 = require("../../utils/subreducers");
const currentReducer = _currentReducer.default('current-bid');
const currentAddendumReducer = _currentReducer.default('current-addendum');
const folderTreeReducer = _folderTreeReducer.default('bid', 'INHERIT_SELECTION');
const billingInformationsReducer = _billingInformationsReducer.Reducer;
exports.initialState = {
    basicInformation: Object.assign({}, basicInformationReducer.initialState),
    billingInformation: Object.assign({}, billingInformationsReducer.initialState),
    current: Object.assign({}, currentReducer.initialState),
    currentAddendum: Object.assign({}, currentAddendumReducer.initialState),
    finishing: Object.assign({}, finishingsReducer.initialState),
    list: Object.assign({}, listReducer.initialState),
    participants: Object.assign({}, participantsReducer.initialState),
    tender: Object.assign({}, tenderReducer.initialState),
    reliablePartnerSettings: Object.assign({}, reliablePartnerSettingsReducer.initialState),
    userGroups: Object.assign({}, userGroupsReducer.initialState),
    messages: Object.assign({}, messagesReducer.initialState),
    message: Object.assign({}, messageReducer.initialState),
    questions: Object.assign({}, questionsReducer.initialState),
    projectCopy: folderTreeReducer.initialState
};
const billingInformationLens = monocle.Lens.fromProp('billingInformation');
const basicInformationLens = monocle.Lens.fromProp('basicInformation');
const currentLens = monocle.Lens.fromProp('current');
const currentAddendumLens = monocle.Lens.fromProp('currentAddendum');
const finishingLens = monocle.Lens.fromProp('finishing');
const listLens = monocle.Lens.fromProp('list');
const participantsLens = monocle.Lens.fromProp('participants');
const tenderLens = monocle.Lens.fromProp('tender');
const reliablePartnerSettingsLens = monocle.Lens.fromProp('reliablePartnerSettings');
const userGroupsLens = monocle.Lens.fromProp('userGroups');
const messagesLens = monocle.Lens.fromProp('messages');
const messageLens = monocle.Lens.fromProp('message');
const questionsLens = monocle.Lens.fromProp('questions');
const projectCopyLens = monocle.Lens.fromProp('projectCopy');
// BasicInformation
const handleBasicInformation = (action) => (state) => {
    const fn = basicInformationReducer.methods[action.type];
    if (fn) {
        const current = basicInformationLens.get(state);
        return basicInformationLens.set(fn(current, action))(state);
    }
    return state;
};
exports.handleBasicInformation = handleBasicInformation;
const handleBillingInformation = (action) => (state) => {
    const fn = billingInformationsReducer.methods[action.type];
    if (fn) {
        const current = billingInformationLens.get(state);
        return billingInformationLens.set(fn(current, action))(state);
    }
    return state;
};
exports.handleBillingInformation = handleBillingInformation;
// Current
const handleCurrentBid = (action) => (state) => {
    const fn = currentReducer.methods[action.type];
    if (fn) {
        const current = currentLens.get(state);
        return currentLens.set(fn(current, action))(state);
    }
    return state;
};
exports.handleCurrentBid = handleCurrentBid;
const handleCurrentAddendum = (action) => (state) => {
    const fn = currentAddendumReducer.methods[action.type];
    if (fn) {
        const current = currentAddendumLens.get(state);
        return currentAddendumLens.set(fn(current, action))(state);
    }
    return state;
};
exports.handleCurrentAddendum = handleCurrentAddendum;
const handleFinishing = (action) => (state) => {
    const fn = finishingsReducer.methods[action.type];
    if (fn) {
        const current = finishingLens.get(state);
        return finishingLens.set(fn(current, action))(state);
    }
    return state;
};
exports.handleFinishing = handleFinishing;
// List
const handleList = (action) => (state) => {
    const fn = listReducer.methods[action.type];
    if (fn) {
        const list = listLens.get(state);
        return listLens.set(fn(list, action))(state);
    }
    return state;
};
exports.handleList = handleList;
// Participants
const handleParticipants = (action) => (state) => {
    const fn = participantsReducer.methods[action.type];
    if (fn) {
        const list = participantsLens.get(state);
        return participantsLens.set(fn(list, action))(state);
    }
    return state;
};
exports.handleParticipants = handleParticipants;
// Tender
const handleTender = (action) => (state) => {
    const fn = tenderReducer.methods[action.type];
    if (fn) {
        const list = tenderLens.get(state);
        return tenderLens.set(fn(list, action))(state);
    }
    return state;
};
exports.handleTender = handleTender;
// User groups
const handleUserGroups = (action) => (state) => {
    const fn = userGroupsReducer.methods[action.type];
    if (fn) {
        const list = userGroupsLens.get(state);
        return userGroupsLens.set(fn(list, action))(state);
    }
    return state;
};
exports.handleUserGroups = handleUserGroups;
// Messages
const handleMessages = (action) => (state) => {
    const fn = messagesReducer.methods[action.type];
    if (fn) {
        const list = messagesLens.get(state);
        return messagesLens.set(fn(list, action))(state);
    }
    return state;
};
exports.handleMessages = handleMessages;
// Message
const handleMessage = (action) => (state) => {
    const fn = messageReducer.methods[action.type];
    if (fn) {
        const list = messageLens.get(state);
        return messageLens.set(fn(list, action))(state);
    }
    return state;
};
exports.handleMessage = handleMessage;
const handleQuestions = (action) => (state) => {
    const fn = questionsReducer.methods[action.type];
    if (fn) {
        const list = questionsLens.get(state);
        return questionsLens.set(fn(list, action))(state);
    }
    return state;
};
exports.handleQuestions = handleQuestions;
const handleCopy = (action) => (state) => {
    const fn = folderTreeReducer.methods[action.type];
    if (fn) {
        const list = projectCopyLens.get(state);
        return projectCopyLens.set(fn(list, action))(state);
    }
    return state;
};
exports.handleCopy = handleCopy;
// Reducer
exports.default = (state = exports.initialState, action) => {
    return fp.function.compose((0, exports.handleCopy)(action), (0, exports.handleBasicInformation)(action), (0, exports.handleBillingInformation)(action), (0, exports.handleCurrentBid)(action), (0, exports.handleCurrentAddendum)(action), (0, exports.handleFinishing)(action), (0, exports.handleList)(action), fp.function.compose((0, exports.handleParticipants)(action), (0, exports.handleTender)(action), (0, exports.handleUserGroups)(action), (0, exports.handleMessages)(action), (0, exports.handleMessage)(action), (0, exports.handleQuestions)(action)), (0, subreducers_1.handleSubreducer)(action, reliablePartnerSettingsReducer, reliablePartnerSettingsLens))(state);
};
//#endregion
//# sourceMappingURL=index.js.map